var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from 'root/src/client/v2/common/helpers/cn';
export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipContent = forwardRef((_a, ref) => {
    var { className, sideOffset = 6 } = _a, props = __rest(_a, ["className", "sideOffset"]);
    return (<TooltipPrimitive.Portal>
		<TooltipPrimitive.Content ref={ref} sideOffset={sideOffset} className={cn('redesign z-[1102] origin-[var(--radix-tooltip-content-transform-origin)] overflow-hidden rounded-md border border-border bg-popover px-3 py-1.5 text-xs text-popover-foreground shadow-md animate-tooltip-in data-[state=closed]:animate-tooltip-out', className)} {...props}/>
	</TooltipPrimitive.Portal>);
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
